import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance, { lienFacture } from "../../api/api";
// import Badge from "react-bootstrap/Badge";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import Spinner from "react-bootstrap/Spinner";
// import { Help } from "../../utils";
import { Galleria } from "primereact/galleria";
// import { Button } from "primereact/button";
import { Header, LoadingSpinner, InfoDetails } from "../../shared/compoments";
import { ProfilHeader } from "../../pages/Profil";
import { LuEye } from "react-icons/lu";
function DetailClient() {
  const navigate = useNavigate();
  const galleria = useRef(null);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [detailClientUser, setDetailClientUser] = useState(null);
  const [detailInfoPhotoContrat, setDetailInfoPhotoContrat] = useState([]);
  const DATA_BTN_WITH_CONTRAT_OPTIONS = [
    {
      titleBtn: "Voir le contrat",
      icone: <LuEye />,
      isColor: false,
      isVisible: true,
      methode: (e) => {
        console.log("Voir le contrat26", JSON.parse(e.target.value));
        setDetailInfoPhotoContrat(JSON.parse(e.target.value));
        if (detailInfoPhotoContrat.length > 0 && galleria.current) {
          galleria.current.show();
        }
      },
    },
    {
      titleBtn: "Voir les factures",
      icone: <LuEye />,
      isColor: false,
      isVisible: true,
      methode: () => {
        navigate("/Contrats/detail-factures/" + id);
      },
    },
  ];
  // const dataInfoDetail = (
  //   date_entree,
  //   date_sortie,
  //   propriety_cost,
  //   propriety_name,
  //   nombre_mois_avance,
  //   nombre_mois_caution,
  //   mois_agence
  // ) => {
  //   const element = [];
  //   element.push(
  //     { title: "DATE DE DEBUT", value: date_entree },
  //     { title: "DATE DE FIN", value: date_sortie },
  //     { title: "CAUTION", value: nombre_mois_caution * propriety_cost },
  //     { title: "AVANCE", value: nombre_mois_avance * propriety_cost },
  //     { title: "BIEN", value: propriety_name }
  //   );
  //   setDetailInfo(element);
  //   console.log("detailInfo85", detailInfo);
  // };
  const itemTemplate = (item) => {
    return (
      <img
        src={lienFacture + item.path}
        alt={item.path}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={lienFacture + item.path}
        alt={item.path}
        style={{ display: "block" }}
      />
    );
  };
  useEffect(() => {
    const getDetailClient = async () => {
      try {
        const response = await instance.get(`/users/${id}`);
        console.log("getDetailClient", response.data.data);
        setDetailClientUser(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    };
    getDetailClient();
  }, [id]);

  if (isLoading) return <LoadingSpinner />;

  return (
    <div>
      <Header libelle={"Détails Client"} isReturn />
      {detailInfoPhotoContrat.length > 0 && (
        <Galleria
          ref={galleria}
          value={detailInfoPhotoContrat}
          numVisible={9}
          style={{ maxWidth: "50%" }}
          circular
          fullScreen
          showItemNavigators
          showThumbnails={false}
          item={itemTemplate}
          thumbnail={thumbnailTemplate}
        />
      )}

      <div className="px-5 mt-3">
        <ProfilHeader
          namePerson={`${detailClientUser.nom} ${detailClientUser.prenom}`}
          detailPhone={detailClientUser.phone}
          detailAdresse={detailClientUser.adresse}
          detailUserInfo={true}
        />
      </div>

      <div className="d-flex justify-content-center gap-2 align-items-center flex-wrap">
        {detailClientUser?.contract.map((item, index) => (
          <>
            <InfoDetails
              arrayForInfoOnContrat={JSON.stringify(item.photos)}
              titleInfo={`Contrat N ${index + 1}`}
              dataInfo={[
                { title: "DATE DE DÉBUT", value: item.date_entree },
                { title: "DATE DE FIN", value: item.date_sortie },
                {
                  title: `CAUTION (${item.nombre_mois_caution} mois)`,
                  value:
                    Number(item.nombre_mois_caution) *
                    Number(item.propriety.cost),
                },
                {
                  title: `AVANCE (${item.nombre_mois_avance} mois)`,
                  value: item.nombre_mois_avance * item.propriety.cost,
                },
                { title: "BIEN", value: item.propriety.nom },
              ]}
              widthBody={"30%"}
              dataBtnWithOptions={
                item?.photos.length > 0 ? DATA_BTN_WITH_CONTRAT_OPTIONS : []
              }
            />
          </>
        ))}
        {!detailClientUser?.contract.length && (
          <h3 className="text-center my-5">Pas de contrat</h3>
        )}
      </div>
    </div>
  );
}

export default DetailClient;
